// extracted by mini-css-extract-plugin
export default {"container":"MainProduct_container__fhktw","wrapper":"MainProduct_wrapper__dFMI+","carousel":"MainProduct_carousel__t8IF7","details":"MainProduct_details__gNXXa"};